import Alpine from 'alpinejs'

Alpine.data('buyNow', (productId: string, buwNowUrl: string, alertPending, alertUnknownError) => ({

    alert: {
        type: null, // pending, success or error
        title: null,
        text: null,
        close: null,
        reload: false, // reload overlay when alert is closed
    },
    showButtonIntent: true,
    showButtonConfirmation: false,
    variantId: null,

    setVariantId(variantId) {
        if(this.showButtonConfirmation) {
            this.showButtonConfirmation = false
            this.showButtonIntent = true
        }
        this.variantId = variantId
    },

    closeAlert() {
        if(this.alert.reload) {
            this.$dispatch('reload-product-overlay')
        } else {
            this.reset()
        }
    },

    reset() {
        this.showButtonIntent = true
        this.showButtonConfirmation = false
        this.alert.type = null
        this.alert.title = null
        this.alert.text = null
        this.alert.reload = false
    },

    buyNowIntent() {
        if(!this.variantId) {
            this.$dispatch('variant-selection-requested')
            return
        }
        this.showButtonIntent = false
        this.showButtonConfirmation = true
        this.$dispatch('buy-now-intent', this.variantId)
    },

    buyNowConfirm() {
        this.showButtonConfirmation = false
        this.alert = {
            type: 'pending',
            ...alertPending
        }

        fetch(buwNowUrl, {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type' : 'application/json',
            },
            body: JSON.stringify({
                variantId: this.variantId
            })
        })
            .then(response => {
                if(!response.ok) {
                    throw new Error('response status '+response.status+'/'+response.statusText)
                }
                return response.json()
            })
            .then(data => {
                if(data.status === 'success') {
                    this.alert = {
                        type: 'success',
                        ...data.alert
                    }
                }
                if(data.status === 'error') {
                    this.alert = {
                        type: 'error',
                        ...data.alert
                    }
                }
                if(data.status === 'info') {
                    this.alert = {
                        type: 'pending',
                        ...data.alert
                    }
                }
                if(data.status === 'unauthenticated') {
                    this.reset()
                    // trigger the session store to update, if the server has a different state than us
                    Alpine.store('session').updateState() 
                    this.$dispatch('login-requested')
                }
                if(data.trackEvent) {
                    window.gtag('event', data.trackEvent.name, data.trackEvent.data || {})
                }
            })
            .catch((error) => {
                console.log(error)
                this.alert = {
                    type: 'error',
                    ...alertUnknownError
                }
            })
    }

}))